import { Flex, Link, List, ListItem, Text } from "@chakra-ui/react";
import React from "react";
import {getCompanyName, getWebsiteUrl} from "../../extensions/stylingExstension";
import config from "../../config";

const companyName = getCompanyName();

export default function Footer() {
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent="space-between"
      px="30px"
      pb="20px"
    >
      <Text
        color="gray.400"
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}
      >
        &copy; {1900 + new Date().getYear()},{" "}
        <Text as="span">
            Gemaakt met ❤️ door {companyName}
        </Text>
      </Text>
      <List display="flex">
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}
        >
          <Link color="gray.400" target="_blank" href={getWebsiteUrl()}>
              {companyName} website
          </Link>
        </ListItem>
      </List>
    </Flex>
  );
}
